// In development  REACT_APP_API_BASE is "" (empty) — requests use relative paths
//   → CRA dev server proxy (setupProxy.js) forwards /api/... to fxbazzar.com:2025
// In production   REACT_APP_API_BASE is "https://fxbazzar.com:2025" — direct calls
const BASE = process.env.REACT_APP_API_BASE || "";

const DEFAULT_HOST = "https://fxbazzar.com:2025";

export const ENV = {
  /** Send cookies on login/API calls; backend must use CORS + SameSite=None + Secure for cross-origin HTTPS. */
  USE_AUTH_COOKIES:
    String(process.env.REACT_APP_USE_AUTH_COOKIES || "").toLowerCase() === "true",
  /** Real / production-style login host */
  LIVE_API: process.env.REACT_APP_LIVE_API || DEFAULT_HOST,
  /** Instance / demo pool (same host unless overridden) — used with “FxBazzar Instance” in login */
  INSTANCE_API: process.env.REACT_APP_INSTANCE_API || DEFAULT_HOST,
  /** Full InstantDemo URL if you need a one-off override */
  DEMO_API: process.env.REACT_APP_DEMO_API || `${DEFAULT_HOST}/api/v1/user/InstantDemo`,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || "https://socket.fxbazzar.com:3000",
};
